import { AgentBuilder } from '../domain';
var CompanyBuilder = /** @class */ (function () {
    function CompanyBuilder(company) {
        var defaultCompany = {
            accountManager: new AgentBuilder().build(),
            name: 'MyHeritage',
            creationDate: new Date().getTime(),
            info: {
                description: 'Hello World',
                logo: 'https://www.tamurajones.net/img/icon/FamilyTreeBuilderIcon.png'
            },
            id: 'test',
            settings: {
                emailDomainSettings: {
                    emailDomains: ['myheritage.com'],
                    autoAssociateUsers: true,
                },
                shareTicketsEnabled: false
            }
        };
        this.company = company || defaultCompany;
    }
    CompanyBuilder.prototype.withId = function (companyId) {
        this.company.id = companyId;
        return this;
    };
    CompanyBuilder.prototype.withName = function (name) {
        this.company.name = name;
        return this;
    };
    CompanyBuilder.prototype.withAccountManager = function (accountManager) {
        this.company.accountManager = accountManager;
        return this;
    };
    CompanyBuilder.prototype.withInfo = function (info) {
        this.company.info = info;
        return this;
    };
    CompanyBuilder.prototype.withSettings = function (settings) {
        this.company.settings = settings;
        return this;
    };
    CompanyBuilder.prototype.withEmailDomainSettings = function (emailDomainSettings) {
        this.company.settings.emailDomainSettings = emailDomainSettings;
        return this;
    };
    CompanyBuilder.prototype.withSlaPolicy = function (defaultSlaPolicyId) {
        this.company.settings.defaultSlaPolicyId = defaultSlaPolicyId;
        return this;
    };
    CompanyBuilder.prototype.withAccountManagerSettings = function (accountManagerSettings) {
        this.company.settings.accountManagerSettings = accountManagerSettings;
        return this;
    };
    CompanyBuilder.prototype.withFollowers = function (followers) {
        this.company.settings.followers = followers;
        return this;
    };
    CompanyBuilder.prototype.withCompanyContacts = function (contacts) {
        this.company.settings.contacts = contacts;
        return this;
    };
    CompanyBuilder.prototype.withCreationDate = function (date) {
        this.company.creationDate = date.getTime();
        return this;
    };
    CompanyBuilder.prototype.withContactEmailAddresses = function (emailAddresses) {
        this.company.contactEmailAddresses = emailAddresses;
        return this;
    };
    CompanyBuilder.prototype.withShareTicketsEnabledSettings = function (shareTicketsEnabled) {
        this.company.settings.shareTicketsEnabled = shareTicketsEnabled;
        return this;
    };
    CompanyBuilder.prototype.build = function () {
        return this.company;
    };
    return CompanyBuilder;
}());
export { CompanyBuilder };
//# sourceMappingURL=builder.js.map